import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { docSubmissionInitialState, DocSubmissionStateProps, docSubmissionStateStore } from './doc-submission-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class DocSubmissionRepository extends BaseStoreRepository<DocSubmissionStateProps> {
  constructor() {
    super(docSubmissionStateStore.pipe(select(state => state)), docSubmissionStateStore, docSubmissionInitialState);
  }
}
